import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useContext } from 'react';
import { useStaticQuery } from 'gatsby';
import { HStack, IconButton, VStack, Divider, useTheme } from '@chakra-ui/react';
import { HamburgerIcon } from '@chakra-ui/icons';
import { MdOutlineContactPhone } from 'react-icons/md';
import { FaFacebook, FaInstagram } from 'react-icons/fa';
import { GlobalContext } from '@interness/web-core/src/providers/GlobalContext';
import { useEcom } from '@interness/web-core/src/hooks/useEcom';
import CartIcon from '@interness/ecommerce-addon/src/components/CartIcon/CartIcon';
import { jsx as ___EmotionJSX } from "@emotion/react";
const PrimaryMenu = () => {
  const data = useStaticQuery(query);
  const theme = useTheme();
  const {
    hasEcom
  } = useEcom();
  const {
    onSidebarOpen,
    setSidebarContent
  } = useContext(GlobalContext);
  const onMenuItemClick = content => {
    setSidebarContent(content);
    onSidebarOpen();
  };
  const colorModeButtonStyles = {
    colorScheme: theme.initialColorMode === 'light' ? 'gray' : 'base',
    variant: theme.initialColorMode === 'light' ? 'ghost' : 'solid'
  };
  const socialIcons = {
    instagram: ___EmotionJSX(FaInstagram, null),
    facebook: ___EmotionJSX(FaFacebook, null)
  };
  const hasPrimaryMenu = data.allDirectusMenusNew.nodes.filter(e => e.position === 'primary').length > 0;
  const hasSocialMenu = data.allDirectusMenusNew.nodes.filter(e => e.position === 'social').length > 0;
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(HStack, {
    justify: "center",
    h: "100%"
  }, ___EmotionJSX(HStack, {
    spacing: 4,
    mr: 4,
    justify: "center",
    sx: {
      p: {
        fontSize: '0.6rem'
      }
    }
  }, hasPrimaryMenu && ___EmotionJSX(VStack, {
    spacing: 0
  }, ___EmotionJSX(IconButton, _extends({
    size: "lg"
  }, colorModeButtonStyles, {
    onClick: () => onMenuItemClick('primaryMenu'),
    "aria-label": "Menu",
    icon: ___EmotionJSX(HamburgerIcon, null)
  })), ___EmotionJSX("p", null, "Men\xFC")), ___EmotionJSX(VStack, {
    spacing: 0
  }, ___EmotionJSX(IconButton, _extends({
    size: "lg"
  }, colorModeButtonStyles, {
    onClick: () => onMenuItemClick('contact'),
    "aria-label": "Kontakt",
    icon: ___EmotionJSX(MdOutlineContactPhone, null)
  })), ___EmotionJSX("p", null, "Kontakt")), hasEcom && ___EmotionJSX(CartIcon, {
    buttonStyle: colorModeButtonStyles
  })), hasSocialMenu && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Divider, {
    orientation: "vertical",
    sx: {
      borderColor: theme.initialColorMode === 'light' ? '#333' : '#fff',
      height: '50px'
    }
  }), ___EmotionJSX(HStack, {
    spacing: 2,
    justify: "center",
    sx: {
      p: {
        fontSize: '0.6rem'
      }
    }
  }, data.socialMediaMenu.config.map(social => ___EmotionJSX(VStack, {
    spacing: 0,
    key: social.external_path
  }, ___EmotionJSX(IconButton, _extends({
    as: 'a',
    href: social.external_path,
    target: "_blank",
    rel: "noopener noreferrer",
    size: "md"
  }, colorModeButtonStyles, {
    "aria-label": social.display_name,
    icon: socialIcons[social.media]
  }))))))));
};
const query = "1041425096";
export default PrimaryMenu;